import { Divider } from "antd";
import { useIntl } from "react-intl";

export const ModalDivider = ({translationKey}) => {
  const { formatMessage } = useIntl();
  return (
    <Divider style={{ margin: "1px 0", borderColor: "#DADADA" }}>
      <div style={{ fontSize: 14, fontWeight: 500 }}>{formatMessage({ id: translationKey })}</div>
    </Divider>
  );
}